/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-23 13:52:52
 * @LastEditors: limin
 * @LastEditTime: 2021-04-19 10:50:34
 */
// import { fetchGet } from "@/api/index" // api文件夹下封装的axios.get请求函数
import {PRODUCTS_SET_PRODUCT,PRODUCTS_SET_DETAIL_PRODUCT,PRODUCTS_SET_ALL_LABELS,PRODUCTS_SET_LABELS_INDEX,PRODUCTS_SET_CATEGORYS,PRODUCTS_SET_CATEGORY_ID} from '../types' // types目录下的mutations函数的常量名
import apis from '@/apis'
const state = {
  recommendList: [], // 存放所有商品的信息
  detailProduct:{},
  labels:[], //所有标签
  labelsIndex:0, //当前标签索引
  categorys:[], // 所有商品分类
  categorysId:0//当前 分类Id
}

const getters = {
  detailProduct: (state, getters) => {
    return state.detailProduct
  },
  curLabel: (state) => {
    return state.labels[state.labelsIndex]
  },
  allLabels: (state) => {
    return state.labels
  },
  allCategory: (state) => {
    return state.categorys
  },
  curCategotyId:(state)=>{
    return state.categorysId
  }
}

const mutations = {
  [PRODUCTS_SET_PRODUCT](state, products) {
    state.recommendList = products
  },
  [PRODUCTS_SET_DETAIL_PRODUCT](state, product) {
    state.detailProduct = product
  },
  [PRODUCTS_SET_ALL_LABELS](state, labels) {
    state.labels = labels
  },
  [PRODUCTS_SET_LABELS_INDEX](state, index) {
    state.labelsIndex = index
  },
  [PRODUCTS_SET_CATEGORYS](state, categorys) {
    state.categorys = categorys
  },
  [PRODUCTS_SET_CATEGORY_ID](state, id) {
    state.categorysId = id
  },
}

const actions = {
  getAllProducts({ commit },data) {
    // apis.goods.list(data).then(list=>{
    //   commit(PRODUCTS_SET_DETAIL_PRODUCT, detail)
    // })
  },
  setDetailProduct({ commit,dispatch },product) {
    const { id } = product
    dispatch("clearDetailProduct") //获取详情前 置空前一个数据对象
    apis.goods.detail(id).then(detail=>{
      commit(PRODUCTS_SET_DETAIL_PRODUCT, detail)
    })
  },
  getLabels({ commit ,state}){
    return new Promise(resolve=>{
      if(state.labels.length){
        resolve(state.labels)
        return
      }
      apis.goods.labels().then(labs=>{
        if(labs.length){
          let _labels = labs.map(lab=>{
            const {id,labelName:name} = lab
            return {id,name}
          })
          commit(PRODUCTS_SET_ALL_LABELS, _labels)
        }
        resolve(state.labels)
      })
    })
  },
  setLabelsIndex({ commit },index) {
    commit(PRODUCTS_SET_LABELS_INDEX, index)
  },
  getCategory({ commit ,state}){
    return new Promise(resolve=>{
      if(state.categorys.length){
        resolve(state.categorys)
        return
      }
      apis.goods.category().then(cates=>{
        if(cates.length){
          const _cates =cates.map(item=>{
            const { code, description,displayPosition,displayed,id,imageUri:imgUrl,name:text,goodsNum,parentId, goodId} = item
            return  { code, description,displayPosition,displayed,id,imgUrl,text,goodsNum,parentId, goodId}
          })
          commit(PRODUCTS_SET_CATEGORYS, _cates)
        }
        resolve(state.categorys)
      })
    })
  },
  setCategoryId({ commit },id) {
    commit(PRODUCTS_SET_CATEGORY_ID, id)
  },
  clearDetailProduct({ commit }){
    commit(PRODUCTS_SET_DETAIL_PRODUCT, {})
  }
}

export default {
  namespaced: true, // 添加命名空间
  state,
  getters,
  mutations,
  actions
}
